module.exports = "//static.hsappstatic.net/ContentUtils/static-1.60506/img/choiceButtons/icon-background-shape-circle.svg"